module.exports = __webpack_public_path__ + "img/q-6.a06e069.png";